
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const ps230: IProductData = {
  id: "miad-ps230",
  name: "Miad Audio 3 Rail Linear Power Supply",
  description: "3 Rail Linear Power Supply",
  specialOrder: true,
  images: ["/img/miad_ps230_front.jpeg","/img/miad_ps230_back.jpeg", "/img/miad_ps230_wire.jpeg"],
  details: [{
    label: "Description",
    markdown: `
The PS 230 is a 3-rail linear power supply capable of powering two LCPQ 4040 MK2 or LCPQ 4040 units, housed in a robust enclosure.

The unit provides ±28V DC for the audio circuit and +24V DC for the relays and the bypass indicator. The additional +24V DC rail ensures that no unwanted noise (caused by the relays and the bypass indicator) is added to the audio.

The front panel is equipped with three LED indicators that provide visual confirmation of the rails’ operational status.

As with all of our products, special care has been taken in the PCB design and the grounding scheme for optimal performance and lowest noise.

The 115VAC/230VAC switch and fuse are accessible to the user at the back of the unit.
`
  }, {
    label: "Features",
    markdown: `
- High efficiency, low noise design
- Capable of powering two units
- Switchable between 115V/ 230V AC
- Dedicated power rails for the audio signal and the relay bypass system
- LED indicators for each power rail at the front of the unit
- High quality 6-pin Neutrik® connectors
- Hand-built and hand-wired
- 3-year labour and parts warranty
`
  }, {
    label: "Technical Specs",
    markdown: `
- Output Voltage: ±28V DC, +24V DC
- Input Voltage: 115V/ 230V AC, 50/60Hz
- Width: 230 mm
- Depth: 170 mm
- Height: 80 mm
- Weight (approx.): 2 kg
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.miadaudio.com/pdf/PS230_Manual_v1.pdf" target="_blank">Operator's Manual</a>
- <a to="https://www.miadaudio.com/productregistration/" target="_blank">Product Registration</a>
- <a to="https://www.miadaudio.com/ps230/" target="_blank">https://www.miadaudio.com/ps230/</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.ACCESSORIES],
    manufacturer: BRAND.MIAD,
  }
}